// import { useTranslations } from 'next-intl';
import { useState } from "react";

import Modal from "../../../../common/Modal";
import CustomLink from "../../../../common/CustomLink";

import "./styles/index.css";
import { ADMIN_API_KEY, API_ENV } from "../../../../../constants";

const ApiKeyInfoModal = ({ isCreate, isEdit, onOutsideClick, onDeleteClick, onCreateClick, onEditClick, onCancelClick, apiKey }) => {
  const [apiKeyName, setApiKeyName] = useState(apiKey?.name ?? "");
  const [apiKeyCallbackURL, setApiKeyCallbackURL] = useState(apiKey?.description ?? "");
  const [apiKeyEnabled, setApiKeyEnabled] = useState(apiKey?.enabled ?? false);

  const onDeleteClickHandler = () => {
    onDeleteClick?.(apiKey);
  }

  const onCreateClickHandler = ({ name }) => {
    onCreateClick?.(name);
  }

  const onEditClickHandler = ({ id, name, callbackUrl, enabled }) => {
    onEditClick?.({ id, name, callbackUrl, enabled });
  }

  const onCancelClickHandler = () => {
    onCancelClick?.();
  }

  const disabledButtons =
    apiKey?.value === ADMIN_API_KEY[API_ENV.DEV] ||
    apiKey?.value === ADMIN_API_KEY[API_ENV.PRD];

  return (
    <Modal
      open={true}
      setOpen={onOutsideClick}
      closeOnOutsideClick={true}
      className="api-key-info-modal"
    >
      <div
        className="container"
        onClick={() => {}} // prevent closing modal on click inside
      >
        <label>
          Name
          <input
            disabled={disabledButtons}
            className="api-key-input primary"
            type="text"
            value={apiKeyName}
            onChange={(e) => setApiKeyName(e.target.value)}
          />
        </label>

        {isEdit && (
          <>
            <label>
              API Key
              <input
                disabled
                className="api-key-input"
                type="text"
                value={apiKey?.value}
              />
              <CustomLink
                to={`/api-requests?api_key=${apiKey.value}`}
              >
                {'See Request Logs'}
              </CustomLink>
            </label>

            <label>
              Callback URL
              <input
                className="api-key-input"
                type="text"
                value={apiKeyCallbackURL}
                onChange={(e) => setApiKeyCallbackURL(e.target.value)}
              />
            </label>

            <label>
              Enabled
              <input
                disabled={disabledButtons}
                className="toggle"
                type="checkbox"
                checked={apiKeyEnabled}
                onChange={(e) => setApiKeyEnabled(e.target.checked)}
              />
            </label>

            <p>Created: {(new Date(apiKey.createdDate)).toLocaleString()}</p>
            <p>Updated: {(new Date(apiKey.lastUpdatedDate)).toLocaleString()}</p>
          </>
        )}

        <div className="buttons-container">
          {isEdit && (
            <>
              {!disabledButtons && (
                <button
                  className="btn tertiary btn--small"
                  onClick={onDeleteClickHandler}
                >
                  {'Delete'}{' '}<span>{'API Key'}</span>
                </button>
              )}

              <button
                className="btn secondary btn--small"
                onClick={() => onEditClickHandler({
                  id: apiKey.id,
                  name: apiKeyName,
                  callbackUrl: apiKeyCallbackURL,
                  enabled: apiKeyEnabled,
                })}
              >
                {'Edit'}{' '}<span>{'API Key'}</span>
              </button>
            </>
          )}

          {isCreate && (
            <button
              className="btn secondary btn--small"
              onClick={() => onCreateClickHandler({
                name: apiKeyName,
                callbackUrl: apiKeyCallbackURL,
                enabled: apiKeyEnabled,
              })}
            >
              {'Create'}{' '}<span>{'API Key'}</span>
            </button>
          )}

          <button
            className="primary btn btn--small"
            onClick={onCancelClickHandler}
          >
            {'Cancel'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApiKeyInfoModal;